import { MessageCircle } from "lucide-react";
import { trackContact } from "@/lib/trackContact";

/**
 * Floating WhatsApp CTA — bottom-right, visible on every page on mobile only.
 * Desktop already has an inline WhatsApp button in the Header.
 */
export default function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/393511294525?text=Ciao%20audrivio%2C%20vorrei%20maggiori%20informazioni"
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contattaci su WhatsApp"
      onClick={() => trackContact("whatsapp", "fab")}
      className="md:hidden fixed bottom-4 right-4 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-[0_6px_20px_rgba(37,211,102,0.45)] hover:shadow-[0_8px_28px_rgba(37,211,102,0.65)] flex items-center justify-center text-white transition-all active:scale-95"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
